module.exports = __webpack_public_path__ + "static/media/cloudbet.1521a9a4.jpg";